/**
 * Planner money tools stored as site_settings JSON (cloud) and/or local *.json files.
 * Used by daily ZIP backup and Maintenance → Download Full Archive.
 */
export const PLANNER_MONEY_BACKUP_ENTRIES = [
  { file: 'deposits.json', settingKey: 'planner_deposits', localFile: 'deposits.json' },
  { file: 'cashflow.json', settingKey: 'planner_cashflow', localFile: 'cashflow.json' },
  { file: 'utilities.json', settingKey: 'planner_utilities', localFile: 'utilities.json' },
  { file: 'utilities_backup.json', settingKey: 'planner_utilities_backup', localFile: 'utilities.backup.json' },
  { file: 'utilities_snapshots.json', settingKey: 'planner_utilities_snapshots', localFile: null },
  { file: 'subscriptions.json', settingKey: 'planner_subscriptions', localFile: 'subscriptions.json' },
  { file: 'cashbacks.json', settingKey: 'planner_cashbacks', localFile: 'cashbacks.json' },
];

export function parseSiteSettingValue(raw) {
  if (raw === null || raw === undefined || raw === '') return null;
  if (typeof raw === 'object') return raw;
  if (typeof raw === 'number' || typeof raw === 'boolean') return raw;
  try {
    return JSON.parse(String(raw));
  } catch {
    return String(raw);
  }
}

/** Build { fileName → value } from site_settings rows. */
export function moneySnapshotsFromSiteSettings(rows = []) {
  const byKey = new Map();
  for (const row of rows || []) {
    const k = String(row?.key || '').trim();
    if (k) byKey.set(k, row.value);
  }
  const out = {};
  for (const entry of PLANNER_MONEY_BACKUP_ENTRIES) {
    if (!byKey.has(entry.settingKey)) continue;
    out[entry.file] = parseSiteSettingValue(byKey.get(entry.settingKey));
  }
  return out;
}
